/**
 * @param {*} context The context (this)
 * @param {function} func The function to execute after the debounce time
 * @param {number} delayMS The amount of time to wait
 * @return {function} The debounced function
 */
export function debounce(context, func, delayMS) {
    let timeout;

    return (...args) => {
        // create clear and run functions
        const cancelTimeout = () => {
            if (timeout) {
                clearTimeout(timeout);
            }
        }
        const runFn = (...args) => func.apply(context, args);

        // the previous timeout then create a new one
        cancelTimeout();
        timeout = setTimeout(runFn(...args), delayMS);

        // return functions that allow the caller to cancel and flush the debounce
        return [
            // flush - cancel the timeout and run straight away
            () => { 
                cancelTimeout();
                runFn(...args);
            },
            // cancel - cancel the timeout
            cancelTimeout
        ];
    };
};

/**
 * @param {*} context The context (this)
 * @param {function} func The function to execute after the debounce time
 * @param {number} delay The amount of time to wait
 * @return {array} [debounceFn, cancelDebounceFn]
 */
 export function useDebounce(context, func, delay) {
    let timeout;

    return [
        // standard debounce
        (...args) => {
            if (timeout) {
                clearTimeout(timeout);
            }

            timeout = setTimeout(() => {
                func.apply(context, args);
            }, delay);
        },
        // flush
        (...args) => {
            if(timeout) {
                clearTimeout(timeout);
            }
            func.apply(context, args);
        },
        // cancel
        () => { 
            if(timeout) clearTimeout(timeout) 
        }
    ];
};